<script>
   /*************************************************************/
   /* ModelLoader                                               */
   /* -------------------------                                 */
   /* loads PCA model from file                                 */
   /*************************************************************/

   import FileSelector from '../../../shared/controls/FileSelector.svelte';
   import Container from '../../../shared/controls/Container.svelte';
   import Button from '../../../shared/controls/Button.svelte';
   import ButtonCancel from '../../../shared/controls/ButtonCancel.svelte';


   /*****************************************/
   /* Component parameters                  */
   /*****************************************/

   // outputs
   export let model;    // object with model


   /*****************************************/
   /* Component code                        */
   /*****************************************/

   // string with model file name
   let modelFile = undefined;

   // app status for handling and showing errors
   let status = 'neutral';
   let errMsg = '';

   // gets model content as one large string, parse it into matrix
   function setModel(strData) {
      try{
         const m = JSON.parse(strData);
         m.v = new Float64Array(m.v);
         if (!Object.keys(m).includes('class') || m.class[0] !== 'pcamodel') {
            throw Error('The JSON file you selected does not contain PCA mdel.');
         }
         model = m;
         status = 'success';
         errMsg = ''
      } catch (e) {
         model = null;
         status = 'error';
         errMsg = e;
      }
   }

   // promise for reading the CSV file
   function readFile (e) {
      const reader = new FileReader();
      reader.onload = () => { setModel(reader.result) };
      reader.readAsText(modelFile);
   }

   function reset() {
      modelFile = null
   }

   // reactive expression for tracking changes of 'modelFile'
   $: if (modelFile === null) {
      // if model file is empty reset status and error messages
      model = null;
   } else {
      // if not just remove error messages if any
      status = 'neutral';
      errMsg = '';
   }

   // file name with model without extension
   $: modelFileName = modelFile ? modelFile.name.replace(/\.[^/.]+$/, "") : '';
</script>

{#if !model }

   <!-- show if data is not loaded -->
   <!-- reset component if dataFile is changed inside -->
   {#key modelFile === undefined}
   <Container>
      <FileSelector id="modelFile" bind:file={modelFile} acceptType=".json" message="Select file with model"/>
   </Container>
   {/key}

   {#if modelFile}
   <Container label="&nbsp;">
      <Button on:click={readFile}>Load</Button>
   </Container>
   {/if}

{:else}

   <!-- dataset is loaded - show info and cancel button -->
   <Container>
      <p class="model-info">
         <span>Model file:</span> <span title="{modelFileName}" class="file-name">{modelFileName}</span><br>
      </p>
      <ButtonCancel on:click={reset} />
   </Container>

{/if}

<!-- error message -->
{#if status === 'error' || errMsg}
<Container status="error">
   <p>{@html errMsg}</p>
</Container>
{/if}


<style>

   .model-info {
      line-height: 1.5em;
   }
   .model-info > :global(span) {
      vertical-align:top;
      color: #a0a0a0;
   }

   .model-info > .file-name {
      display: inline-block;
      padding: 0;
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 25ch;
      color: #222;
   }

</style>